export const EVENT_SWIFT_MESSAGE_ORDER_CREATE = 'swiftMessageOrder.create'

export const EVENT_SWIFT_MESSAGE_ORDER_UPDATE = 'swiftMessageOrder.update'
